<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<div class="wa-stack wa-gap-m content-section">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<div class="hero-eyebrow" waCaption="s" waFontWeight="semibold" waText>RUNTIME</div>
				<h2 waHeading="l" waText>Reactive Server Architecture</h2>
				<p waBody="m" waColorText="quiet" waText>Vert.x event loop, Guice DI, call scopes, and SPA hosting.</p>
			</div>
			<div class="wa-stack wa-gap-m">
				<div class="wa-grid wa-gap-m" style="--min-column-size:20rem;">
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>Boot &rarr; Inject &rarr; Serve</h3>
							<p waBody="m" waColorText="quiet" waText>Boot.main&#40;&#41; sets system properties and calls IGuiceContext.inject&#40;&#41;. Guice scans modules, discovers SPI implementations, binds services, and starts the Vert.x HTTP server &mdash; all from a single line.</p>
						</div>
					</wa-card>
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>Vert.x Routes</h3>
							<p waBody="m" waColorText="quiet" waText>JWebMPVertx registers routes automatically: GET / for pages, POST /jwajax for AJAX events, GET /jwdata for data components, GET /jwcss for CSS, and /eventbus for STOMP WebSocket.</p>
						</div>
					</wa-card>
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>Call Scopes</h3>
							<p waBody="m" waColorText="quiet" waText>Every HTTP request enters a Guice CallScope. RoutingContext, request, response, and session data are available via injection anywhere in the call chain.</p>
						</div>
					</wa-card>
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>SPA Fallback</h3>
							<p waBody="m" waColorText="quiet" waText>Static assets are served from the Angular dist/ directory. Unmatched routes fall back to index.html for Angular Router client-side navigation.</p>
						</div>
					</wa-card>
				</div>
			</div>
		</div>
	</div>
</div>